import React from 'react';
import {
  Box,
  Paper,
  Button,
  Typography,
  Alert,
} from '@mui/material';
import { getSiteflowLoginUrl } from '../services/siteflowSso';

// Resolved once at build time from REACT_APP_SITEFLOW_URL.
const SITEFLOW_LOGIN_URL = getSiteflowLoginUrl();

const Login = ({ error = '' }) => {
  const message = SITEFLOW_LOGIN_URL ? error : 'Sign-in is not configured. Please contact support.';

  return (
    <Box
      sx={{
        minHeight: '100vh',
        backgroundColor: '#000000',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: 2,
      }}
    >
      <Paper
        elevation={0}
        sx={{
          p: 4,
          width: '100%',
          maxWidth: 400,
          backgroundColor: '#161616',
          border: '1px solid rgba(255, 255, 255, 0.08)',
          borderRadius: 2,
        }}
      >
        {/* Header */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          {/* Company Logo */}
          <Box sx={{ mb: 3 }}>
            <img
              src="/logo.webp"
              alt="Company Logo"
              style={{
                height: '60px',
                maxWidth: '200px',
                objectFit: 'contain',
              }}
            />
          </Box>

          <Typography
            variant="h4"
            sx={{
              color: '#ffffff',
              fontWeight: 600,
              mb: 1,
            }}
          >
            AI Photo Gallery
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: 'rgba(255, 255, 255, 0.6)',
            }}
          >
            Sign in to access your photo gallery
          </Typography>
        </Box>

        {/* Error Alert */}
        {message && (
          <Alert
            severity="error"
            sx={{
              mb: 3,
              backgroundColor: 'rgba(244, 67, 54, 0.1)',
              border: '1px solid rgba(244, 67, 54, 0.3)',
              color: 'rgba(255, 255, 255, 0.9)',
              '& .MuiAlert-icon': {
                color: '#f44336',
              },
            }}
          >
            {message}
          </Alert>
        )}

        {/* Sign in through SiteFlow (JumpCloud SSO) */}
        <Button
          fullWidth
          variant="contained"
          href={SITEFLOW_LOGIN_URL || undefined}
          disabled={!SITEFLOW_LOGIN_URL}
          sx={{
            py: 1.5,
            backgroundColor: '#333333',
            color: '#ffffff',
            fontWeight: 500,
            '&:hover': {
              backgroundColor: '#444444',
            },
            '&:disabled': {
              backgroundColor: 'rgba(255, 255, 255, 0.08)',
              color: 'rgba(255, 255, 255, 0.3)',
            },
          }}
        >
          Sign in with SiteFlow
        </Button>

        {/* Footer */}
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Typography
            variant="caption"
            sx={{
              color: 'rgba(255, 255, 255, 0.4)',
            }}
          >
            You'll sign in with your company account through SiteFlow
          </Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default Login;
